import React from 'react';

import {MainLayout} from 'widgets/layout';
import {listPageClassName} from 'shared/ui/ListPage/ListPage';
import {AdminUsersScreen} from 'features/admin';

const AdminUsersPage: React.FC = () => (
    <MainLayout className={listPageClassName}>
        <AdminUsersScreen />
    </MainLayout>
);

export default AdminUsersPage;
